import { DelayCodesManager } from "./components/DelayCodesManager";

type Props = {
	delayAreaAssetId?: number;
	delayAreaAssetName?: string;
};

export const CatalogDelayCodePage = ({
	delayAreaAssetId,
	delayAreaAssetName,
}: Props) => {
	return (
		<DelayCodesManager
			delayAreaAssetId={delayAreaAssetId}
			delayAreaAssetName={delayAreaAssetName}
		/>
	);
};
